import React from 'react';
import PropTypes from 'prop-types';
import Moment from 'moment';
import Grid from 'material-ui/Grid';
import { push } from 'react-router-redux';
import { store } from '../../../redux/store/configureStore';
import Button from '../../atoms/Button';
import Icon from '../Icon';


const OrderSummary = ({
  transactionId,
  deliveryDate,
  orderStatus,
  orderValue,
  orderDate,
}) => (
  <div className="order-summary">
    <Grid container className="height__max order-summary--container">
      <Grid item md={2} sm={3} lg={3} xl={3} className="order-summary--expected-delivery">
        <p className="font-body font-body--tablet mb__10">
          Expected
        </p>
        <p className="heading-2 font-lato m__0">
          {Moment(deliveryDate, 'MM-DD-YYY').format('DD')}
        </p>
        <p className="heading-2 font-lato m__0">
          {Moment(deliveryDate, 'MM-DD-YYY').format('MMM')}
        </p>
      </Grid>
      <Grid item className="order-summary--expected-delivery__container" sm={6}>
        <p className="text-align__center font-body">
          Expected
        </p>
        <p className="mt__0 font-color__blue heading-3 text-align__center font-body--tablet">
          {Moment(deliveryDate, 'MM-DD-YYY').format('ddd DD MMM')}
        </p>
      </Grid>
      <Grid item md={7} sm={6} lg={6} xl={6} className="pl__15">
        <div className="order-summary--order-number__mobile">
          <p className="font-body font-body--tablet">
            Ref No: {transactionId}
          </p>
        </div>
        <div className="height__20 height__30--tablet">
          <p
            className="m__0 heading-3
            heading-3--tablet
            font-lato font-color__green order-summary--order-status__mobile-container"
          >
            <span className="some-class">
              <span className="hide-desktop icon order-summary--icon__timer">
                <Icon icon="timer" />
              </span>
              <span className="order-summary--order-status__mobile">
                {orderStatus === 'Enroute' ? 'In transit' : orderStatus}
              </span>
            </span>
          </p>
        </div>
        <div className="height__60px order-summary--order-value-container">
          <span className="float__left mr__30 mr__10--tablet order-summary--order-value">
            <p className="mb__5 font-body font-body--tablet hide-mobile darkGreyLabel">
              {orderValue === 0 ? '' : 'Total Value'}
            </p>
            <span className="icon icon__timer hide-desktop order-summary--order-value__float-left">
              <Icon icon="bill" />
            </span>
            <p className="m__0 pr__30
            pr__10--tablet
            font-body font-body--tablet order-summary--order-value__float-right"
            >
              {orderValue === 0 ? '' : `£${orderValue}`}
            </p>
          </span>
          <span className={`float__left hide-mobile ${orderValue === 0 ? 'negative-margin-lef-150' : ''}`}>
            <p className="mb__5 font-body font-body--tablet darkGreyLabel">
              Date Placed
            </p>
            <p className="m__0 font-body font-body--tablet">
              {Moment(orderDate, 'MM-DD-YYYY').format('ddd DD MMM YY')}
            </p>
          </span>
        </div>
      </Grid>
      <Grid item md={3} sm={3} lg={4} xl={4}>
        <Grid
          container
          alignItems="flex-end"
          className="height__max flex-end primary-button-container"
        >
          <Button
            text="View Order"
            onClick={() => {
              store.dispatch(push({ pathname: `/order-details/${transactionId}` }));
            }}
          />
        </Grid>
      </Grid>
    </Grid>
  </div>);

OrderSummary.propTypes = {
  transactionId: PropTypes.string.isRequired,
  deliveryDate: PropTypes.string.isRequired,
  orderStatus: PropTypes.string.isRequired,
  orderValue: PropTypes.string.isRequired,
  orderDate: PropTypes.string.isRequired,
};

export default OrderSummary;



// WEBPACK FOOTER //
// src/components/molecules/OrderSummary/index.jsx